import WsService from "../WsService";
import OutboundPaymentInitResponse from "../../domain/Transaction/payment/OutboundPaymentInitResponse";

const BASEURL = '/transactions'
export default class OutboundPaymentService {
    static initiatePayment(paymentPartnerId, transactionId, paymentRequest) {

        let url = BASEURL + '/' + transactionId + '/payment/request'
        let headers = {'payment-partner-id': paymentPartnerId}

        return WsService.postWithHeaders(url,paymentRequest, 200, headers).then(
            response => {
                return new OutboundPaymentInitResponse(response)
            },
            error => {
                return error;
            }
        )
    }
}